// extracted by mini-css-extract-plugin
export default {"popup__title":"mediaDevicesErrorPopup_popup__title__Ee6Kq","popup__img":"mediaDevicesErrorPopup_popup__img__6e+zK","popup__text":"mediaDevicesErrorPopup_popup__text__VWH2F"};